(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const cartItems = document.querySelectorAll('.cart-item');

    cartItems.forEach(function(item) {
      const quantityInput = item.querySelector('.cart-item__quantity-input');
      const minusBtn = item.querySelector('[data-action="decrease"]');
      const plusBtn = item.querySelector('[data-action="increase"]');
      const removeBtn = item.querySelector('[data-action="remove"]');
      const lineIndex = quantityInput.dataset.line;
      let isUpdating = false;

      function updateCart(quantity, optimisticValue) {
        if (isUpdating) return;
        isUpdating = true;

        // Optimistic UI update
        if (optimisticValue !== undefined) {
          quantityInput.value = optimisticValue;
        }

        // Add loading state
        item.style.opacity = '0.7';
        item.style.pointerEvents = 'none';

        fetch('/cart/change.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            line: parseInt(lineIndex),
            quantity: quantity
          })
        })
        .then(response => response.json())
        .then(data => {
          window.location.reload();
        })
        .catch(error => {
          console.error('Error:', error);
          isUpdating = false;
          item.style.opacity = '1';
          item.style.pointerEvents = 'auto';
        });
      }

      minusBtn.addEventListener('click', function() {
        const currentQty = parseInt(quantityInput.value);
        if (currentQty > 1) {
          updateCart(currentQty - 1, currentQty - 1);
        }
      });

      plusBtn.addEventListener('click', function() {
        const currentQty = parseInt(quantityInput.value);
        updateCart(currentQty + 1, currentQty + 1);
      });

      removeBtn.addEventListener('click', function() {
        item.style.opacity = '0.5';
        updateCart(0);
      });

      quantityInput.addEventListener('change', function() {
        const newQty = parseInt(this.value);
        if (newQty >= 0) {
          updateCart(newQty);
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    // Sort functionality
    const sortSelect = document.querySelector('[data-sort-select]');
    if (sortSelect) {
      sortSelect.addEventListener('change', function() {
        const url = new URL(window.location.href);
        url.searchParams.set('sort_by', this.value);
        window.location.href = url.toString();
      });
    }

    // Read more functionality
    const readMoreBtn = document.getElementById('read-more-btn');
    const descriptionText = document.getElementById('collection-description');

    if (readMoreBtn && descriptionText) {
      readMoreBtn.addEventListener('click', function() {
        descriptionText.classList.toggle('is-expanded');
        this.textContent = descriptionText.classList.contains('is-expanded')
          ? 'Read Less'
          : 'Read More';
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    // Mega Menu functionality
    const menuToggle = document.querySelector('.header__menu-toggle');
    const megaMenu = document.querySelector('.mega-menu');
    const menuClose = document.querySelector('.mega-menu__close');

    function closeMenu() {
      if (megaMenu) {
        megaMenu.classList.remove('is-open');
        document.body.style.overflow = '';
      }
      if (menuToggle) {
        menuToggle.setAttribute('aria-expanded', 'false');
      }
    }

    function openMenu() {
      if (megaMenu) {
        megaMenu.classList.add('is-open');
        // Lock body scroll on mobile when menu is open
        if (window.innerWidth <= 768) {
          document.body.style.overflow = 'hidden';
        }
      }
      if (menuToggle) {
        menuToggle.setAttribute('aria-expanded', 'true');
      }
    }

    if (menuToggle && megaMenu) {
      menuToggle.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        const isOpen = megaMenu.classList.contains('is-open');
        if (isOpen) {
          closeMenu();
        } else {
          openMenu();
        }
      });

      // Close button handler
      if (menuClose) {
        menuClose.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          closeMenu();
        });
      }

      // Close on overlay click (only on mobile)
      document.addEventListener('click', function(e) {
        if (megaMenu.classList.contains('is-open') &&
            !e.target.closest('.header__mega-menu-wrapper') &&
            !e.target.closest('.mega-menu')) {
          closeMenu();
        }
      });

      // Close on escape key
      document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape' && megaMenu.classList.contains('is-open')) {
          closeMenu();
        }
      });
    }

    // Predictive Search functionality
    const searchInput = document.querySelector('[data-predictive-search-input]');
    const predictiveSearch = document.querySelector('[data-predictive-search]');
    const resultsContainer = document.querySelector('[data-predictive-search-results]');

    if (!searchInput || !predictiveSearch || !resultsContainer) return;

    let debounceTimer;
    let abortController;

    function debounce(func, delay) {
      return function(...args) {
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(() => func.apply(this, args), delay);
      };
    }

    function formatMoney(cents) {
      return new Intl.NumberFormat('en-GB', {
        style: 'currency',
        currency: window.Shopify?.currency?.active || 'GBP'
      }).format(cents / 100);
    }

    async function performSearch(query) {
      if (abortController) {
        abortController.abort();
      }
      abortController = new AbortController();

      predictiveSearch.classList.add('is-active', 'is-loading');

      try {
        const response = await fetch(
          `/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product,collection,page,query&resources[limit]=6&resources[limit_scope]=each`,
          { signal: abortController.signal }
        );

        if (!response.ok) throw new Error('Search failed');

        const data = await response.json();
        const results = data.resources?.results || {};

        renderResults(results, query);
      } catch (error) {
        if (error.name !== 'AbortError') {
          console.error('Search error:', error);
          resultsContainer.innerHTML = '<p class="predictive-search__no-results">Something went wrong. Please try again.</p>';
        }
      } finally {
        predictiveSearch.classList.remove('is-loading');
      }
    }

    function renderResults(results, query) {
      const queries = results.queries || [];
      const products = results.products || [];
      const collections = results.collections || [];
      const pages = results.pages || [];

      const hasResults = queries.length > 0 || products.length > 0 || collections.length > 0 || pages.length > 0;

      if (!hasResults) {
        resultsContainer.innerHTML = `
          <div class="predictive-search__no-results">
            <p class="predictive-search__no-results-text">No results found for "${escapeHtml(query)}"</p>
            <div class="predictive-search__suggestions">
              <p class="predictive-search__suggestions-title">Try searching for:</p>
              <div class="predictive-search__suggestion-links">
                <a href="/search?q=cleaning&type=product&source=fromHeaderSearch" class="predictive-search__suggestion-link">Cleaning supplies</a>
                <a href="/search?q=paper&type=product&source=fromHeaderSearch" class="predictive-search__suggestion-link">Paper products</a>
                <a href="/search?q=soap&type=product&source=fromHeaderSearch" class="predictive-search__suggestion-link">Soap</a>
              </div>
            </div>
            <div class="predictive-search__quick-links">
              <p class="predictive-search__quick-links-title">Quick links:</p>
              <a href="/collections/all" class="predictive-search__quick-link">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <rect x="3" y="3" width="7" height="7"/><rect x="14" y="3" width="7" height="7"/>
                  <rect x="3" y="14" width="7" height="7"/><rect x="14" y="14" width="7" height="7"/>
                </svg>
                Browse all products
              </a>
              <a href="/pages/contact-us" class="predictive-search__quick-link">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
                  <polyline points="22,6 12,13 2,6"/>
                </svg>
                Contact us
              </a>
            </div>
          </div>
        `;
        return;
      }

      let html = '';

      // Popular searches (queries)
      if (queries.length > 0) {
        html += `
          <div class="predictive-search__section">
            <h3 class="predictive-search__section-title">Popular searches</h3>
            ${queries.map(q => `
              <a href="/search?q=${encodeURIComponent(q.text)}&type=product&source=fromHeaderSearch" class="predictive-search__result-item predictive-search__query-item">
                <span class="predictive-search__query-icon">
                  <svg width="16" height="16" viewBox="0 0 20 20" fill="none">
                    <circle cx="8" cy="8" r="6" stroke="currentColor" stroke-width="2"/>
                    <path d="M12.5 12.5L17 17" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
                  </svg>
                </span>
                <span class="predictive-search__query-text">${escapeHtml(q.text)}</span>
              </a>
            `).join('')}
          </div>
        `;
      }

      // Products
      if (products.length > 0) {
        html += `
          <div class="predictive-search__section">
            <h3 class="predictive-search__section-title">Products</h3>
            ${products.map(product => {
              const image = product.featured_image?.url
                ? product.featured_image.url.replace(/\.([^.]+)$/, '_100x100.$1')
                : 'https://cdn.shopify.com/s/files/1/0533/2089/files/placeholder-images-image_large.png';

              const price = formatMoney(product.price);
              const comparePrice = product.compare_at_price_max > product.price
                ? `<span class="predictive-search__result-price-compare">${formatMoney(product.compare_at_price_max)}</span>`
                : '';

              return `
                <a href="${product.url}" class="predictive-search__result-item predictive-search__product-item">
                  <img
                    src="${image}"
                    alt="${escapeHtml(product.title)}"
                    class="predictive-search__result-image"
                    loading="lazy"
                  >
                  <div class="predictive-search__result-content">
                    <p class="predictive-search__result-title">${escapeHtml(product.title)}</p>
                    <p class="predictive-search__result-price">${price}${comparePrice}</p>
                  </div>
                </a>
              `;
            }).join('')}
          </div>
        `;
      }

      // Collections
      if (collections.length > 0) {
        html += `
          <div class="predictive-search__section">
            <h3 class="predictive-search__section-title">Collections</h3>
            ${collections.map(collection => {
              const image = collection.featured_image?.url
                ? collection.featured_image.url.replace(/\.([^.]+)$/, '_100x100.$1')
                : null;

              return `
                <a href="${collection.url}" class="predictive-search__result-item predictive-search__collection-item">
                  ${image ? `
                    <img
                      src="${image}"
                      alt="${escapeHtml(collection.title)}"
                      class="predictive-search__result-image"
                      loading="lazy"
                    >
                  ` : `
                    <span class="predictive-search__collection-icon">
                      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                        <rect x="3" y="3" width="7" height="7"/>
                        <rect x="14" y="3" width="7" height="7"/>
                        <rect x="3" y="14" width="7" height="7"/>
                        <rect x="14" y="14" width="7" height="7"/>
                      </svg>
                    </span>
                  `}
                  <div class="predictive-search__result-content">
                    <p class="predictive-search__result-title">${escapeHtml(collection.title)}</p>
                  </div>
                </a>
              `;
            }).join('')}
          </div>
        `;
      }

      // Pages
      if (pages.length > 0) {
        html += `
          <div class="predictive-search__section">
            <h3 class="predictive-search__section-title">Pages</h3>
            ${pages.map(page => `
              <a href="${page.url}" class="predictive-search__result-item predictive-search__page-item">
                <span class="predictive-search__page-icon">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
                    <polyline points="14 2 14 8 20 8"/>
                    <line x1="16" y1="13" x2="8" y2="13"/>
                    <line x1="16" y1="17" x2="8" y2="17"/>
                    <polyline points="10 9 9 9 8 9"/>
                  </svg>
                </span>
                <div class="predictive-search__result-content">
                  <p class="predictive-search__result-title">${escapeHtml(page.title)}</p>
                </div>
              </a>
            `).join('')}
          </div>
        `;
      }

      html += `
        <a href="/search?q=${encodeURIComponent(query)}&type=product&source=fromHeaderSearch" class="predictive-search__view-all">
          View all results for "${escapeHtml(query)}"
        </a>
      `;

      resultsContainer.innerHTML = html;
    }

    function escapeHtml(text) {
      const div = document.createElement('div');
      div.textContent = text;
      return div.innerHTML;
    }

    function closeSearch() {
      predictiveSearch.classList.remove('is-active', 'is-loading');
      resultsContainer.innerHTML = '';
    }

    // Event listeners
    const debouncedSearch = debounce(function(query) {
      if (query.length >= 2) {
        performSearch(query);
      } else {
        closeSearch();
      }
    }, 300);

    searchInput.addEventListener('input', function(e) {
      debouncedSearch(e.target.value.trim());
    });

    searchInput.addEventListener('focus', function() {
      if (this.value.trim().length >= 2) {
        performSearch(this.value.trim());
      }
    });

    // Close on click outside
    document.addEventListener('click', function(e) {
      if (!e.target.closest('.header__search')) {
        closeSearch();
      }
    });

    // Close on escape key
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') {
        closeSearch();
        searchInput.blur();
      }
    });

    // Keyboard navigation
    searchInput.addEventListener('keydown', function(e) {
      const items = resultsContainer.querySelectorAll('.predictive-search__result-item');
      const currentFocus = document.activeElement;
      const currentIndex = Array.from(items).indexOf(currentFocus);

      if (e.key === 'ArrowDown') {
        e.preventDefault();
        if (currentIndex < 0) {
          items[0]?.focus();
        } else if (currentIndex < items.length - 1) {
          items[currentIndex + 1].focus();
        }
      } else if (e.key === 'ArrowUp') {
        e.preventDefault();
        if (currentIndex > 0) {
          items[currentIndex - 1].focus();
        } else if (currentIndex === 0) {
          searchInput.focus();
        }
      }
    });

    resultsContainer.addEventListener('keydown', function(e) {
      const items = resultsContainer.querySelectorAll('.predictive-search__result-item');
      const currentIndex = Array.from(items).indexOf(document.activeElement);

      if (e.key === 'ArrowDown' && currentIndex < items.length - 1) {
        e.preventDefault();
        items[currentIndex + 1].focus();
      } else if (e.key === 'ArrowUp') {
        e.preventDefault();
        if (currentIndex > 0) {
          items[currentIndex - 1].focus();
        } else {
          searchInput.focus();
        }
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  (function() {
    const form = document.querySelector('[data-product-form]');
    if (!form) return;

    const variantSelect = form.querySelector('[data-variant-select]');
    const optionButtons = form.querySelectorAll('[data-option-value]');
    const optionSelects = form.querySelectorAll('[data-option-select]');
    const addButton = form.querySelector('[data-add-to-cart]');
    const priceEl = document.querySelector('[data-product-price]');
    const priceVatEl = document.querySelector('[data-product-price-vat]');
    const compareEl = document.querySelector('[data-product-compare-price]');

    const vatRate = 0.20;

    function formatMoney(cents) {
      return (cents / 100).toLocaleString('en-GB', {
        style: 'currency',
        currency: 'GBP'
      });
    }

    function getSelectedOptions() {
      const options = {};
      optionButtons.forEach(function(btn) {
        if (btn.classList.contains('product-page__variant-button--selected')) {
          options[btn.dataset.optionPosition] = btn.dataset.optionValue;
        }
      });
      optionSelects.forEach(function(select) {
        options[select.dataset.optionSelect] = select.value;
      });
      return options;
    }

    function findVariant(options) {
      const variantOptions = variantSelect.querySelectorAll('option');
      for (let i = 0; i < variantOptions.length; i++) {
        const opt = variantOptions[i];
        let matches = true;
        for (const pos in options) {
          if (opt.dataset['option' + pos] !== options[pos]) {
            matches = false;
            break;
          }
        }
        if (matches) return opt;
      }
      return null;
    }

    function updateVariant() {
      const options = getSelectedOptions();
      const variant = findVariant(options);

      if (variant) {
        variantSelect.value = variant.value;

        const price = parseInt(variant.dataset.price, 10);
        const comparePrice = variant.dataset.comparePrice ? parseInt(variant.dataset.comparePrice, 10) : null;
        const available = variant.dataset.available === 'true';

        if (priceEl) priceEl.textContent = formatMoney(price);
        if (priceVatEl) {
          const priceIncVat = Math.round(price * (1 + vatRate));
          priceVatEl.textContent = formatMoney(priceIncVat);
        }

        if (compareEl) {
          if (comparePrice && comparePrice > price) {
            compareEl.textContent = formatMoney(comparePrice);
            compareEl.parentElement.style.display = '';
          } else {
            compareEl.parentElement.style.display = 'none';
          }
        }

        if (addButton) {
          addButton.disabled = !available;
          addButton.textContent = available ? 'Add to basket' : 'Sold out';
        }

        // Update URL
        const url = new URL(window.location);
        url.searchParams.set('variant', variant.value);
        window.history.replaceState({}, '', url);
      }
    }

    // Option button clicks
    optionButtons.forEach(function(btn) {
      btn.addEventListener('click', function() {
        const position = this.dataset.optionPosition;
        const buttonsInGroup = form.querySelectorAll('[data-option-position="' + position + '"]');
        buttonsInGroup.forEach(function(b) {
          b.classList.remove('product-page__variant-button--selected');
        });
        this.classList.add('product-page__variant-button--selected');
        updateVariant();
      });
    });

    // Option select changes
    optionSelects.forEach(function(select) {
      select.addEventListener('change', updateVariant);
    });

    // Product recommendations
    const recommendationsEl = document.getElementById('product-recommendations');
    if (recommendationsEl) {
      const productId = recommendationsEl.dataset.productId;
      const url = '/recommendations/products?product_id=' + productId + '&limit=8&section_id=product-recommendations';

      fetch(url)
        .then(function(response) {
          return response.text();
        })
        .then(function(html) {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');
          const content = doc.getElementById('product-recommendations');
          if (content && content.innerHTML.trim()) {
            recommendationsEl.innerHTML = content.innerHTML;
          }
        })
        .catch(function(err) {
          console.error('Failed to load recommendations:', err);
        });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const carousel = document.querySelector('[data-carousel]');
    const track = document.querySelector('[data-carousel-track]');
    const prevBtn = document.querySelector('[data-carousel-prev]');
    const nextBtn = document.querySelector('[data-carousel-next]');

    if (!carousel || !track || !prevBtn || !nextBtn) return;

    let currentPosition = 0;
    const items = track.querySelectorAll('.search-empty__carousel-item');
    if (items.length === 0) return;

    function getItemsPerView() {
      const width = window.innerWidth;
      if (width <= 480) return 1;
      if (width <= 768) return 2;
      if (width <= 992) return 3;
      if (width <= 1200) return 4;
      return 5;
    }

    function getItemWidth() {
      const item = items[0];
      const style = window.getComputedStyle(track);
      const gap = parseInt(style.gap) || 16;
      return item.offsetWidth + gap;
    }

    function updateButtons() {
      const itemsPerView = getItemsPerView();
      const maxPosition = Math.max(0, items.length - itemsPerView);
      prevBtn.disabled = currentPosition <= 0;
      nextBtn.disabled = currentPosition >= maxPosition;
    }

    function slide(direction) {
      const itemsPerView = getItemsPerView();
      const maxPosition = Math.max(0, items.length - itemsPerView);
      const itemWidth = getItemWidth();

      if (direction === 'next' && currentPosition < maxPosition) {
        currentPosition = Math.min(currentPosition + 1, maxPosition);
      } else if (direction === 'prev' && currentPosition > 0) {
        currentPosition = Math.max(currentPosition - 1, 0);
      }

      track.style.transform = `translateX(-${currentPosition * itemWidth}px)`;
      updateButtons();
    }

    prevBtn.addEventListener('click', () => slide('prev'));
    nextBtn.addEventListener('click', () => slide('next'));

    window.addEventListener('resize', function() {
      const itemsPerView = getItemsPerView();
      const maxPosition = Math.max(0, items.length - itemsPerView);
      currentPosition = Math.min(currentPosition, maxPosition);
      const itemWidth = getItemWidth();
      track.style.transform = `translateX(-${currentPosition * itemWidth}px)`;
      updateButtons();
    });

    updateButtons();
  });

  } catch(e) { console.error(e); }
})();
})();
